import { Injectable, signal } from '@angular/core';
import type { GetMobileAppLinksResponse } from '../models/mobile-app-links.model';
import mobileStoreLinks from '../../../../assets/config/mobile-store-links.json';

@Injectable({
  providedIn: 'root'
})
export class MobileAppLinksService {
  private readonly mobileAppLinksData = signal<GetMobileAppLinksResponse | null>(
    mobileStoreLinks as GetMobileAppLinksResponse
  );

  getMobileAppLinks(): GetMobileAppLinksResponse | null {
    return this.mobileAppLinksData();
  }
}
